import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import CryptoJS from 'crypto-js';
import image from '../assets/images/BashaaratLogo.svg';
import leftimage from '../assets/images/login-left-img.png'
import defaultemail from '../assets/images/register_icon/mail_gray.svg'
import emailimage from '../assets/images/register_icon/mail_brown.svg';
import passimage from '../assets/images/register_icon/lock_brown.svg';
import defaultpass from '../assets/images/register_icon/lock_gray.svg'
import '../styles/AdminLogin.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const ResetPassword = () => {

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);
  const [isConfirmPasswordFocused, setIsConfirmPasswordFocused] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const navigate = useNavigate();

  const encryptPassword = (password) => {
    const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(password, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    const combined = iv.concat(encrypted.ciphertext);
    return CryptoJS.enc.Base64.stringify(combined);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (!token) {
      setErrorMessage("Invalid reset link.");
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }


    try {
      const response = await api.post('adminapi/reset-password', {
        token: token,
        new_password: password
      });

      if (response.data.status === "success") {
        setSuccessMessage(response.data.message);
        setTimeout(() => {
          navigate('/login');

        }, 3000);
      }

    } catch (error) {

      if (error.response && error.response.data) {
        setErrorMessage(error.response.data.message + "Redirecting please wait..");
      } else {
        setErrorMessage('Something went wrong. Please try again later.');
      }

    }
  };

  return (
    <div>
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12 col-md-2 col-lg-12">
              <div className="form-container-login">
                <div className="row">
                  <div className="col-lg-6 p-0">
                    <img className="img-fluid hideinmob" src={leftimage} alt="" style={{ height: '100vh', width: '100%' }} />
                  </div>
                  <div className="col-lg-6 form-center">
                    <div className="login-logo text-center">
                      <img className="logoimg imginmob" src={image} alt="" />
                    </div>
                    <div className="login-head text-center">
                    </div>
                    <div className="login-border">
                      <form className="login-form" onSubmit={handleSubmit}>

                        {/* Password */}
                        <div className="input-container" style={{ borderBottom: isPasswordFocused ? '1px solid #BC6C25' : '1px solid #E4C8AF' }}>
                          <img className="img-fluid" src={isPasswordFocused ? passimage : defaultpass} alt="" />
                          <input
                            type={showPassword ? "text" : "password"}
                            className="email-placeholder"
                            placeholder="Password"
                            onFocus={() => setIsPasswordFocused(true)}
                            onBlur={() => setIsPasswordFocused(false)}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                          />
                          <img className="img-fluid" onClick={() => setShowPassword(!showPassword)} src={isPasswordFocused ? passimage : defaultpass} alt="" />
                        </div>

                        {/* Confirm Password */}
                        <div className="input-container" style={{ borderBottom: isConfirmPasswordFocused ? '1px solid #BC6C25' : '1px solid #E4C8AF' }}>
                          <img className="img-fluid" src={isConfirmPasswordFocused ? passimage : defaultpass} alt="" />
                          <input
                            type="password"
                            className="email-placeholder"
                            placeholder="Confirm Password"
                            onFocus={() => setIsConfirmPasswordFocused(true)}
                            onBlur={() => setIsConfirmPasswordFocused(false)}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                          />
                        </div>

                        {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}
                        {successMessage && <div className="alert alert-success mt-3">{successMessage}</div>}

                        <button type="submit" className="login-btn">
                          Reset Password
                        </button>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResetPassword;
